import { AuthProvider } from 'react-admin';
import { apiUrl, httpClient, resetUserConfig } from './data.provider';
import { User } from '../interfaces/user.interface';

const LOCAL_STORAGE_TOKEN = 'jwt-token';

export const jwtAuthProvider: AuthProvider = {
	login: async ({ username, password }) => {
		const { json } = await httpClient(`${apiUrl}/auth/login`, {
			method: 'POST',
			body: JSON.stringify({ email: username, password })
		});

		localStorage.setItem(LOCAL_STORAGE_TOKEN, JSON.stringify(json.data));
	},
	checkError: (error) => {
		const status = error.status;
		if (status === 401 || status === 403) {
			return Promise.reject({ message: false });
		}
		return Promise.resolve();
	},
	checkAuth: () => localStorage.getItem(LOCAL_STORAGE_TOKEN)
		? Promise.resolve()
		: Promise.reject(),
	logout: () => {
		localStorage.removeItem(LOCAL_STORAGE_TOKEN);
		resetUserConfig();

		return Promise.resolve();
	},
	getIdentity: async () => {
		const { json } = await httpClient(`${apiUrl}/auth/me`, { method: 'GET' });

		return {
			id: json.data.user?.id,
			fullName: json.data.user?.fullName || json.data.user?.organization?.name || 'שם לא ידוע',
			avatar: json.data.user?.profileImageUrl || json.data.user?.organization?.name
		};
	},
	getPermissions: () => {
		const userData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOKEN) ?? '');

		if (userData.user) {
			return Promise.resolve((userData.user as User));
		}

		return Promise.reject();
	}
};
